import { useFormik } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { Link, useNavigate } from "react-router-dom";
import { registerSchema } from "../utils/validations";
import { useRegisterMutation } from "../store";
import { RegisterData } from "../types";
import Logo from "../components/common/Logo";

const Register = () => {
  const [register, { isLoading }] = useRegisterMutation();
  const navigate = useNavigate();

  const handleSubmitForm = async (values: RegisterData) => {
    const result = await register(values);
    if (!result.error && result.data) {
      navigate(`/auth/verify-code?email=${result.data.email}`); // TODO : make routes in config no hard code
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<RegisterData>({
    initialValues: {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
      password: "",
      confirmPassword: "",
      address: {
        street: "",
        zipCode: "",
        city: "",
        country: "",
      },
    },
    validationSchema: registerSchema,
    onSubmit: handleSubmitForm,
  });

  return (
    <div className="w-full flex min-h-screen">
      <div className="w-full md:w-1/2 h-full flex flex-col items-center mt-12 p-4 border-r">
        <form className="mx-auto w-3/5 flex flex-col items-center gap-3">
          <Logo />
          <div className="text-start w-full text-xl mt-4 font-semibold">
            Inscription
          </div>
          <TextField
            id="email"
            value={values.email || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Email"
          />
          <TextField
            id="lastName"
            value={values.lastName || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Nom"
          />
          <TextField
            id="firstName"
            value={values.firstName || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Prénom"
          />
          <TextField
            id="phone"
            value={values.phone || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Téléphone"
          />
          <TextField
            id="password"
            value={values.password || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Mot de passe"
            hideable
          />
          <TextField
            id="confirmPassword"
            value={values.confirmPassword || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Confirmer le mot de passe"
            hideable
          />
          <div className="w-full text-start text-xl mt-4 font-semibold">
            Adresse
          </div>
          <TextField
            id="address.street"
            value={values.address?.street || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.address?.street}
            errors={errors.address?.street}
            placeholder="Rue"
          />
          <TextField
            id="address.zipCode"
            value={values.address?.zipCode || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.address?.zipCode}
            errors={errors.address?.zipCode}
            placeholder="Code postal"
          />
          <TextField
            id="address.city"
            value={values.address?.city || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.address?.city}
            errors={errors.address?.city}
            placeholder="Ville"
          />
          <TextField
            id="address.country"
            value={values.address?.country || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.address?.country}
            errors={errors.address?.country}
            placeholder="Pays"
          />
          <Button
            className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
            disabled={isSubmitting || isLoading}
            type="submit"
            onClick={handleSubmit}
          >
            S&apos;inscrire
          </Button>
          <div className="mt-4 w-full h-0.5 bg-secondary" />
          <div className="mt-4">Vous avez déja un compte ?</div>
          <Link
            to="/auth/login"
            className="font-semibold text-primary underline decoration-primary/50"
          >
            Se connecter
          </Link>
        </form>
      </div>
      <img
        className="hidden md:block w-1/2 min-h-screen h-auto object-cover"
        src="/assets/images/auth-banner.jpg"
      />
    </div>
  );
};

export default Register;
